<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">需求作废状态分布</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>业务需求作废的各个状态数据统计</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div slot="extra">
        <a-radio-group v-model="showModal" button-style="solid" size="small" @change="getTaskPointRank">
          <a-radio-button value="bar"> 柱状图 </a-radio-button>
          <a-radio-button value="pie"> 圆饼图 </a-radio-button>
        </a-radio-group>
      </div>
      <div ref="countRef" :style="{ height: height, width: width }" />
    </a-card>
    <BusinessRequirementListModal ref="businessRequirementListModalRef" />
  </div>
</template>
<script>
import BusinessRequirementListModal from '@/pages/business/requirement/components/BusinessRequirementListModal';
import { getBrInvalidCollecter } from '@/api/business/requirement';
const echarts = require('echarts/lib/echarts');
export default {
  components: { BusinessRequirementListModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'bar',
      loading: true,
      myChart: null,
      // 柱状图配置
      optionBar: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          // axisLabel: {
          //   interval: 0,
          //   rotate: 45
          // },
          axisLabel: {
            interval: 0,
            formatter: function (value) {
              // 如果标签长度超过4，将剩余的文字替换为省略号
              value = value.replace('MRD', '');
              if (value.length > 5) {
                return value.slice(0, 5) + '...';
              } else {
                return value;
              }
            }
          }
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            endValue: 18
          }
        ]
      },
      optionPie: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          show: false
        },
        series: [
          {
            name: '需求总数',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [],
            label: {
              formatter: '{b} ({d}%)',
              fontSize: 12
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      },
      data: []
    };
  },
  watch: {
    filterForm() {
      this.getTaskPointRank();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    // const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/pie'); // 饼图
    require('echarts/lib/chart/line');
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(this.$refs.countRef);
    // 柱状图-点击事件
    this.myChart.on('click', params => {
      // 打印当前点击柱状的数据
      const statuObj = this.$store.getters.getGlobalBusinessStatus();
      const values = Object.values(statuObj);
      for (const key in statuObj) {
        const obj = statuObj[key];
        if (obj.title === params.name) {
          this.$refs.businessRequirementListModalRef.open(params.name, { statusList: [key], isInvalid: true });
          return;
        }
      }
    });
    this.getTaskPointRank();
  },
  beforeDestroy() {
    // 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    changeType() {},
    drawChart() {
      if (this.showModal === 'bar') {
        this.myChart.setOption(this.optionBar, true);
      } else {
        this.myChart.setOption(this.optionPie, true);
      }
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getTaskPointRank() {
      this.loading = true;
      getBrInvalidCollecter({ ...this.filterForm })
        .then(res => {
          this.data = res.data;
          const statuObj = this.$store.getters.getGlobalBusinessStatus();
          if (this.showModal === 'bar') {
            const x_axis = [];
            const yDataList = [];
            for (const key in statuObj) {
              // eslint-disable-next-line no-prototype-builtins
              if (statuObj.hasOwnProperty(key)) {
                const d = this.data.find(it => it.name + '' === key + '');
                x_axis.push(statuObj[key].title);
                // console.log(key + ': ' + statuObj[key].title, d);
                if (d) {
                  yDataList.push(d.count);
                } else {
                  yDataList.push(0);
                }
              }
            }

            this.optionBar.xAxis.data = x_axis;
            this.optionBar.series = [
              {
                type: 'bar',
                label: {
                  show: true,
                  position: 'top'
                },
                name: '需求个数',
                data: yDataList,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#83bff6' },
                    { offset: 0.5, color: '#188df0' },
                    { offset: 1, color: '#188df0' }
                  ])
                }
              }
            ];
          } else {
            const dataList = [];
            for (const key in statuObj) {
              // eslint-disable-next-line no-prototype-builtins
              if (statuObj.hasOwnProperty(key)) {
                // console.log(key + ': ' + statuObj[key].title);
                const d = this.data.find(it => it.name === key);
                if (d) {
                  dataList.push({
                    value: d.count,
                    name: statuObj[key].title
                  });
                } else {
                  dataList.push({
                    value: 0,
                    name: statuObj[key].title
                  });
                }
              }
            }
            this.optionPie.series[0].data = dataList;
          }
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
</style>
